import CustomerAPI from 'config/api/CustomerAPI';
import { getDeviceId } from 'helpers/StorageHelper';
import { manageAPICall } from 'store/auth/actions/CommonCrudAction';
export const getProductFilters = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.productFilters.url,
    CustomerAPI.productFilters.method,
    data
  );
  return response;
};
export const getProductList = async (data: object) => {
  // session_id lets the backend attribute a guest's search term to a single visitor.
  const response = await manageAPICall(
    CustomerAPI.productList.url,
    CustomerAPI.productList.method,
    {
      ...data,
      session_id: getDeviceId(),
    }
  );
  return response;
};
export const getProductDetails = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.productDetails.url,
    CustomerAPI.productDetails.method,
    data
  );
  return response;
};
export const productMakeOffer = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.productMakeOffer.url,
    CustomerAPI.productMakeOffer.method,
    data
  );
  return response;
};
export const notifyMeForStock = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.notifyMeForStock.url,
    CustomerAPI.notifyMeForStock.method,
    data
  );
  return response;
};
export const getGlobalSearch = async (data: object) => {
  const response = await manageAPICall(
    CustomerAPI.globalSearch.url,
    CustomerAPI.globalSearch.method,
    { ...data, session_id: getDeviceId() }
  );
  return response;
};
